import type { WorkspacePhone } from './api';
import { typeLabel } from './format';
import type { CloudQueueControl } from '../types';

export const phoneDisplayName=(phone:{name:string;serial:string})=>`${phone.name} · ${phone.serial.slice(-6)}`;

export function phoneTaskLabel(phone: WorkspacePhone) {
  const entry = phone.queue.find(item=>item.task.status==='running') || phone.queue[0];
  return entry ? `${typeLabel(entry.task.platform || '')} · ${entry.task.name || typeLabel(entry.task.task_type)} · ${Math.round(entry.task.progress||0)}%` : '暂无任务';
}

// Display only: ownership and resume protection still use the server control facts.
export function cloudPauseReason(cloud: CloudQueueControl | undefined | null):string {
  if(!cloud?.paused)return '';
  if(cloud.pause_reason_message?.trim())return cloud.pause_reason_message.trim();
  return '暂停原因未提供，请查看任务记录';
}

export function phonePauseReason(phone: WorkspacePhone):string {
  return cloudPauseReason(phone.cloud_queue_control);
}
